<template>
  <div
    class="relative bg-gray-800 shadow-md shadow-blue-700 rounded-xl border border-blue-500 text-gray-300 py-2 px-2 transition-all"
  >
    <button
      type="button"
      class="absolute right-2 top-2 text-gray-400 flex-none text-sm inline-flex justify-center items-center hover:text-blue-500"
      @click="this.hide"
    >
      <svg
        class="w-3 h-3"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
        />
      </svg>
    </button>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-2 items-center">
      <div class="text-sm flex items-center gap-2">
        <div class="font-bold hidden md:block">Transfer to</div>
        <input
          type="text"
          placeholder="Recipient address"
          class="w-[95%] md:w-96 flex-none py-1 px-2 text-sm bg-transparent rounded-xl border border-gray-600 focus:outline-none focus:ring-0"
          v-model="recipientAddress"
        />
      </div>
      <div class="flex flex-wrap items-center gap-4 2xl:gap-6">
        <div class="text-sm flex items-center gap-2">
          <a
            target="_blank"
            :href="this.explorerUrlAddress(this.wallet.address)"
            class="font-bold hover:underline hover:text-blue-500"
          >
            {{ this.wallet.name }}:
          </a>
        </div>
        <div class="flex justify-between items-center">
          <div class="text-sm gap-1 flex items-center">
            <div class="font-bold text-red-400">
              {{ balanceFormat(this.balanceNative(this.wallet.address)) }}
            </div>
            <div>{{ this.wrappedToken }}</div>
          </div>
        </div>
        <div
          v-if="this.tokenAddress"
          class="flex justify-between items-center gap-4"
        >
          <div class="text-sm gap-1 flex items-center">
            <div
              v-if="
                (this.balanceToken(this.wallet.address) /
                  this.metadata.totalSupply) *
                  100 >=
                1
              "
              class="relative flex h-3 w-3"
            >
              <span
                class="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"
              ></span>
              <span
                class="relative inline-flex rounded-full h-3 w-3 bg-sky-500"
              ></span>
            </div>
            <div
              v-if="this.balanceToken(this.wallet.address) > 0"
              class="text-xs italic"
            >
              ({{
                (
                  (this.balanceToken(this.wallet.address) /
                    this.metadata.totalSupply) *
                  100
                ).toFixed(2)
              }}%)
            </div>
            <div class="font-bold text-red-400">
              {{ balanceFormat(this.balanceToken(this.wallet.address)) }}
            </div>
            <div class="text-sm">{{ this.metadata.symbol }}</div>
          </div>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="w-[18px] text-gray-500 cursor-pointer"
          :class="{
            'animate-spin': this.onRefresh,
          }"
          @click="this.refresh"
        >
          <path
            fill-rule="evenodd"
            d="M4.755 10.059a7.5 7.5 0 0 1 12.548-3.364l1.903 1.903h-3.183a.75.75 0 1 0 0 1.5h4.992a.75.75 0 0 0 .75-.75V4.356a.75.75 0 0 0-1.5 0v3.18l-1.9-1.9A9 9 0 0 0 3.306 9.67a.75.75 0 1 0 1.45.388Zm15.408 3.352a.75.75 0 0 0-.919.53 7.5 7.5 0 0 1-12.548 3.364l-1.902-1.903h3.183a.75.75 0 0 0 0-1.5H2.984a.75.75 0 0 0-.75.75v4.992a.75.75 0 0 0 1.5 0v-3.18l1.9 1.9a9 9 0 0 0 15.059-4.035.75.75 0 0 0-.53-.918Z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>
    <div class="mt-2 grid grid-cols-1 lg:grid-cols-2 gap-2 md:gap-4">
      <div class="bg-gray-900/50 px-2 py-1.5 rounded-xl overflow-hidden">
        <div class="flex items-center justify-between gap-2">
          <div class="text-sm font-bold">{{ this.wrappedToken }}</div>
          <div class="gap-1 flex items-center flex-nowrap">
            <kbd
              class="text-center p-1 cursor-pointer text-[11px] w-[40px] bg-transparent border shadow-md border-gray-500 rounded-xl hover:text-blue-500 hover:border-blue-500 hover:shadow-blue-500"
              v-for="(value, key) in this.options"
              :key="key"
              @click="
                this.balanceNativeModel =
                  (this.balanceNative(this.wallet.address) * value) / 100
              "
              :class="{
                'hidden md:block': value !== 50 && value !== 100,
              }"
            >
              {{ value }}%
            </kbd>
          </div>
          <input
            type="text"
            class="max-w-[120px] text-right bg-transparent border border-gray-500 text-sm rounded-xl block w-full py-1 px-2 focus:outline-none focus:ring-0"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
            v-model="balanceNativeModel"
          />
          <button
            type="button"
            class="focus:outline-none bg-gray-700 border border-blue-700 shadow-md shadow-blue-500 hover:shadow-blue-700 text-blue-300 hover:text-blue-500 uppercase font-bold rounded-xl text-sm px-3 py-1"
            @click="this.transferBalanceNative"
          >
            Send
          </button>
        </div>
      </div>
      <div
        v-if="this.tokenAddress"
        class="bg-gray-900/50 px-2 py-1.5 rounded-xl overflow-hidden"
      >
        <div class="flex items-center justify-between gap-2">
          <div class="text-sm font-bold">
            ${{ this.metadata.symbol.substring(0, 15) }}
          </div>
          <div class="gap-1 flex items-center flex-nowrap">
            <kbd
              class="text-center p-1 cursor-pointer text-[11px] w-[40px] bg-transparent border shadow-md border-gray-500 rounded-xl hover:text-blue-500 hover:border-blue-500 hover:shadow-blue-500"
              v-for="(value, key) in this.options"
              :key="key"
              @click="
                this.balanceTokenModel =
                  (this.balanceToken(this.wallet.address) * value) / 100
              "
              :class="{
                'hidden md:block': value !== 50 && value !== 100,
              }"
            >
              {{ value }}%
            </kbd>
          </div>
          <input
            type="text"
            class="max-w-[120px] text-right bg-transparent border border-gray-500 text-sm rounded-xl block w-full py-1 px-2 focus:outline-none focus:ring-0"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
            v-model="balanceTokenModel"
          />
          <button
            type="button"
            class="focus:outline-none bg-gray-700 border border-blue-700 shadow-md shadow-blue-500 hover:shadow-blue-700 text-blue-300 hover:text-blue-500 uppercase font-bold rounded-xl text-sm px-3 py-1"
            @click="this.transferBalanceToken"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "TransferPopup",
  props: {
    wallet: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
    refresh: {
      type: Function,
      required: true,
    },
    onRefresh: {
      type: Boolean,
      required: true,
    },
    submitTransferBalanceNative: {
      type: Function,
      required: true,
    },
    submitTransferBalanceToken: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      recipientAddress: null,
      balanceNativeModel: 0,
      balanceTokenModel: 0,
      options: {
        10: 10,
        30: 30,
        50: 50,
        80: 80,
        100: 100,
      },
    };
  },
  computed: {
    ...mapGetters("app", ["balanceFormat"]),
    ...mapGetters("network", [
      "shortAddress",
      "wrappedToken",
      "explorerUrlAddress",
    ]),
    ...mapGetters("wallet", ["network", "balanceNative", "balanceToken"]),
    ...mapState({
      metadata(state) {
        switch (this.network) {
          case "solana":
            return state.solana.metadata;
          case "ethereum":
          case "base":
          case "bsc":
          default:
            return state.ethereum.metadata;
        }
      },
      tokenAddress(state) {
        switch (this.network) {
          case "solana":
            return state.solana.tokenAddress;
          case "ethereum":
          case "base":
          case "bsc":
          default:
            return state.ethereum.tokenAddress;
        }
      },
    }),
  },
  watch: {},
  methods: {
    hide() {
      this.balanceNativeModel = 0;
      this.balanceTokenModel = 0;
      this.recipientAddress = null;
      this.close();
    },
    transferBalanceNative() {
      this.$store.commit("toast/add", {
        type: "info",
        title: `Transfer ${this.wrappedToken}`,
        content: `${this.wallet.name} submit transfer ${this.balanceFormat(
          this.balanceNativeModel
        )} ${this.wrappedToken}`,
      });
      return this.submitTransferBalanceNative(
        this.recipientAddress,
        this.balanceNativeModel
      );
    },
    transferBalanceToken() {
      this.$store.commit("toast/add", {
        type: "info",
        title: `Transfer ${this.metadata.symbol}`,
        content: `${this.wallet.name} submit transfer ${this.balanceFormat(
          this.balanceTokenModel
        )} ${this.metadata.symbol}`,
      });
      return this.submitTransferBalanceToken(
        this.recipientAddress,
        this.balanceTokenModel
      );
    },
  },
  mounted() {},
  beforeUnmount() {},
};
</script>
